<template>
  <div class="card-detail-request">
    <header>
      <div
        aria-label="Icono de usuario no bonificado"
        :class="{
          'icon-container' : true,
        }"
      >
        <i
          :class="{
            'icon-container__icon' : true,
            'pi pi-times': true,
          }"
        ></i>
      </div>
      <h1>
        No se cumplen los requisitos.
      </h1>
    </header>
    <section>
      <div class="body__description">
        <p>
          Se ha tramitado la solicitud, pero no se cumplen
          los requisitos para aplicar los descuentos.
        </p>
        <p>
          Más información en <a
            href="https://www.transportes.gob.es/transporte_terrestre/verano-joven"
            :aria-label="`Enlace a la página de información de ${mainText}`"
          >“{{ mainText }}”</a>
        </p>
      </div>
    </section>
  </div>
</template>

<script setup>
// #region VUE
import {
  computed,
} from 'vue';
import {useStore} from 'vuex';
// #endregion

// #region COMPONENTS COMPOSABLES
// ...
// #endregion

// #region Props, Emits
// ...
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const mainText = computed(() => store.getters['text/getSectionTexts']('main'));
// #endregion

// #region Functions
// ...
// #endregion

// #region Effects, Hooks
// ...
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;
.card-detail-request{
  align-items: center;
  display: flex;
  flex-direction: column;

  gap: $brand__boxspace--medium;
  padding: $brand__boxspace--medium * 2;

  header, section{
    align-items: center;
    display: flex;
    flex-direction: column;

    text-align: center;

    gap: $brand__boxspace--medium;
  }

  header{
    gap: $brand__boxspace--medium * 2;
    .icon-container{
      background-color: $pv__color--red;
      border-radius: $pv__br--circle;
      color: $pv__color--white;
      flex: 1;
      padding: $brand__boxspace--medium;
      width: fit-content;
      &__icon{
        @include media("<=phone") {
          font-size: $pv__dm__icon--largue;
        }
        @include media(">phone") {
          font-size: $pv__dm__icon--largue;
        }
      }
    }
  }

  section{
    .body__description{
      align-items: center;
      display: flex;
      flex-direction: column;
      & p {
        font-size: $pv__fs--large;
        & a{
          color: $pv__color--green-alter;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>

